import {
  DIAPER_EMOJI,
  DIAPER_KINDS,
  DIAPER_LABEL,
  type DiaperKind,
  TYPE_EMOJI,
} from "../../../lib/entry-text.ts";
import { Button } from "../../ui/button.tsx";
import { Sheet } from "../../ui/sheet.tsx";

/** One tap logs the change — no confirm step at 3am. */
export function ChangeSheet({
  open,
  babyName,
  onClose,
  onPick,
}: {
  open: boolean;
  babyName: string;
  onClose: () => void;
  onPick: (kind: DiaperKind) => void;
}) {
  return (
    <Sheet open={open} title={`Change — ${babyName}`} emoji={TYPE_EMOJI.diaper} onClose={onClose}>
      <div className="mt-4 flex flex-col gap-2.5">
        {DIAPER_KINDS.map((k) => (
          <Button key={k} variant="choice" className="gap-3" onClick={() => onPick(k)}>
            <span aria-hidden="true" className="w-[52px] shrink-0 whitespace-nowrap text-[20px]">
              {DIAPER_EMOJI[k]}
            </span>
            {DIAPER_LABEL[k]}
          </Button>
        ))}
      </div>
    </Sheet>
  );
}
